import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { useEventListener } from 'taboola-ultimate-ui';

export const useNodeWindowOverflow = ({ trigger, requiredWidth }) => {
    const containerRef = useRef();
    const [overflowWidth, setOverflowWidth] = useState(0);
    const alignStyle = useCallback(() => {
        if (!containerRef.current) {
            return;
        }

        const bounding = containerRef.current.getBoundingClientRect();
        setOverflowWidth(Math.min(0, window.innerWidth - (bounding.x + requiredWidth)));
    }, [requiredWidth]);

    useLayoutEffect(() => {
        alignStyle();
    }, [trigger, alignStyle]);

    useEventListener('resize', alignStyle);

    return {
        containerRef,
        overflowWidth,
    };
};
